import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { menu as menuConstants, state as stateConstants } from 'src/constants';
import { FetchData } from 'src/core/components';
import { DesignType } from 'src/models';
import { getList, remove } from 'src/core/redux/actions';
import { selectListData, selectListFetchData } from 'src/core/redux/selectors';

import { selectSataticMenuItems } from './selectors';
import { getMenuGroups } from './helper';
import MCPLayoutComponent from './MCPLayoutComponent';
import './MCPLayoutStyle.scss';

const MCPLayoutContainer = ({
  fetchData,
  designTypes,
  fetchDataProps,
  resetData,
  staticMenuItems
}) => {
  const [selectedMenuItem, setSelectedMenuItem] = useState({
    category: {
      name: menuConstants.VIEW_ALL,
      categoryNr: ''
    },
    subcategory: {
      name: '',
      subcategoryNr: ''
    },
  });

  const isViewAllActive = selectedMenuItem.category.name === menuConstants.VIEW_ALL;

  return (
    <FetchData
      whenToFetch={isViewAllActive}
      fetchData={fetchData}
      resetData={resetData}
      {...fetchDataProps}
    >
      <MCPLayoutComponent
        {...{
          isViewAllActive,
          selectedMenuItem,
          setSelectedMenuItem,
          menuGroups: getMenuGroups(designTypes),
          overviewData: designTypes,
          staticMenuItems
        }}
      />
    </FetchData>
  );
};

MCPLayoutContainer.propTypes = {
  designTypes: PropTypes.array,
  fetchDataProps: PropTypes.object,
  staticMenuItems: PropTypes.array,
  fetchData: PropTypes.func,
  resetData: PropTypes.func
};

const mapStateToProps = (state) => ({
  designTypes: selectListData(DesignType)(state)?.list,
  fetchDataProps: selectListFetchData(DesignType)(state),
  staticMenuItems: selectSataticMenuItems(state)
});

const mapDispatchToProps = {
  fetchData: getList(DesignType),
  resetData: remove(DesignType.NAME, stateConstants.IDENTIFIER_TYPE_LIST)
};

export default connect(mapStateToProps, mapDispatchToProps)(MCPLayoutContainer);
